// extracted by mini-css-extract-plugin
module.exports = {"placeholder_image":"ProgressiveImg_placeholder_image__2IAwJ"};